import * as angular from "angular";

export class ProductService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = "/v2/product";
    }

    all(): Promise<object> {
        return this.$http.get(`${this.apiRoot}/all`);
    }

    previewInvoice(params: {
        stripeid: string;
        quantity: number;
    }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/preview_invoice`, {
            params: params,
        });
    }

    previewNextInvoice(params: {
        couponid: any;
        removeCoupon: any;
    }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/preview_next_invoice`, {
            params: params,
        });
    }

    previewFirstInvoice(params: {
        stripeid: string;
        couponid: string;
        removeCoupon: string;
    }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/preview_first_invoice`, {
            params: params,
        });
    }

    previewPlanChange(params: {
        stripeid: string;
        couponid: string;
        removeCoupon: string;
        conversionType: string;
    }): Promise<object> {
        return this.$http.get(`${this.apiRoot}/preview_plan_change`, {
            params: params,
        });
    }

    changeQuantity(data: any): Promise<object> {
        return this.$http.post(`${this.apiRoot}/change_quantity`, data);
    }
}

angular.module("vcServices").service("ProductService", ProductService);
